(function ($) {
    'use strict';
    $(window).on('load', function () {
        $('.bs-preloader__wrp').fadeOut("slow", "swing");
        $('body').removeClass('disScroll');
    });
} (jQuery));
